import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';
// import { authHeader } from '../_helpers';

export const userActions = {
    login,
    tokenLogin,
    
    logout,
    register,
    getAll,
    delete: _delete,
    getUser
};

function login(email, password, prevlink) {
    // console.log(email, password)
    return dispatch => {
        dispatch(request({ email }));

        userService.login(email, password)
            .then(
                user => { 
                    dispatch(success(user));
                    userService.toCandidate(JSON.parse(String(localStorage.getItem('user'))).token)
                    .then(json=>{
                        userService.checkInfo(JSON.parse(String(localStorage.getItem('user'))).token)
                    .then(
                        json=>{
                            localStorage.setItem('is_headhunter', json["is_headhunter"])
                            localStorage.setItem('is_recruiter', json["is_recruiter"])
                            if(prevlink.pathname === '/' || 
                            prevlink.pathname === '/resume'){
                                if(json["school#"] === 0 && json["work#"] === 0 && json["resume#"] === 0 ){
                                    history.push('/signIn');
                                }
                                else{
                                    history.push('/profile');
                                }
                            }
                            else if(prevlink.pathname.split('/')[1] === 'recruiter'){
                                if(json["company#"] === 0){
                                    history.push('/recruiter/signIn');
                                }
                                else{
                                    history.push('/recruiter/profile');
                                }
                            
                            } 
                            else {
                                console.log("GGG")
                                history.push(prevlink.pathname)
                                window.location.reload()
                            }
                            // console.log(history)
                        })
                    })
                    if(history.location.hash) {
                        console.log("")
                        history.push('#/');
                        window.location.reload();
                    }
                    else {
                        console.log("YEAH")
                        history.push('/');
                    }
                    
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

// function tokenConfirmLogin(email, token){

// }

export function tokenLogin(e, token, index, prevlink) {
    // debugger
    console.log(token)
    return dispatch => {
        dispatch(request({ token }));
        console.log(token)
        userService.tokenLogin(e, token, index)
            .then(
                user => {
                    console.log(user)
                    userService.toCandidate(JSON.parse(String(localStorage.getItem('user'))).token)
                    .then(json=>{
                        userService.checkInfo(JSON.parse(String(localStorage.getItem('user'))).token)
                    .then(
                        json=>{
                            localStorage.setItem('is_headhunter', json["is_headhunter"])
                            localStorage.setItem('is_recruiter', json["is_recruiter"])
                            if(prevlink.pathname === '/' || 
                            prevlink.pathname === '/resume'){
                                if(json["school#"] === 0 && json["work#"] === 0 && json["resume#"] === 0 ){
                                    history.push('/signIn');
                                }
                                else{
                                    history.push('/profile');
                                }
                            }
                            else if(prevlink.pathname.split('/')[1] === 'recruiter'){
                                if(json["company#"] === 0){
                                    history.push('/recruiter/signIn');
                                }
                                else{
                                    history.push('/recruiter/profile');
                                }
                            
                            } 
                            else {
                                console.log("GGG")
                                history.push(prevlink.pathname)
                                window.location.reload()
                            }
                            // console.log(history)
                        })
                    })
                    
                    dispatch(success(token));
                    
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            )
            .then( user=>{
                
            })
    };

    function request(token) { return { type: userConstants.FBLOGIN_REQUEST, token } }
    function success(token) { return { type: userConstants.FBLOGIN_SUCCESS, token } }
    function failure(error) { return { type: userConstants.FBLOGIN_FAILURE, error } }
}

function logout() {
    userService.logout();
    history.push('/');
    window.location.reload();
    return { type: userConstants.LOGOUT };
}

function register(user) {
    return dispatch => {
        dispatch(request(user));

        userService.register(user)
            .then(
                user => { 
                    dispatch(success());
                    if(history.location.hash) {
                        history.push('#/verifyingEmail');
                        // window.location.reload();
                    }
                    else 
                        history.push('/verifyingEmail');
                        dispatch(alertActions.success('Registration successful'));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
    function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

function getUser(){
    return dispatch => {
        dispatch(request());

        userService.getUser()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error))
            );
    };

    function request(users) { return { type: userConstants.GETALL_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

function getAll() {
    return dispatch => {
        dispatch(request());

        userService.getAll()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: userConstants.GETALL_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        userService.delete(id)
            .then(
                user => { 
                    dispatch(success(id));
                },
                error => {
                    dispatch(failure(id, error));
                }
            );
    };

    function request(id) { return { type: userConstants.DELETE_REQUEST, id } }
    function success(id) { return { type: userConstants.DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: userConstants.DELETE_FAILURE, id, error } }
}